import type { InternalSubtaskTemplatePersistMode } from './changePersistInternalSubtaskTemplate';

/**
 * Redisparar só dispara subtarefas selecionadas — não regrava o catálogo de campos do modelo.
 * A edição do modelo continua em Cadastros / editor de checklist.
 */
export function shouldPersistInternalTemplatesBeforePackage(opts: {
  templatePersistMode: InternalSubtaskTemplatePersistMode | null;
  prefillLikeCreate: boolean;
}): boolean {
  return Boolean(opts.templatePersistMode && !opts.prefillLikeCreate);
}
